import { render, staticRenderFns } from "./DecisionCommentView.vue?vue&type=template&id=29368dd3&"
import script from "./DecisionCommentView.vue?vue&type=script&lang=ts&"
export * from "./DecisionCommentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports